import projectsContent from '@content/projects.yaml'
import type { ProjectsContent } from '@/types/content'

const content = projectsContent as unknown as ProjectsContent

export function Projects() {
  return (
    <section id="projects" className="projects-section">
      <div className="ey ey-lt reveal">{content.eyebrow}</div>
      <h2 className="sh2 sh2-lt reveal d2" dangerouslySetInnerHTML={{ __html: content.headline }} />
      <p className="slead slead-lt reveal d3">{content.lead}</p>

      <div className="flagship-grid">
        {content.flagship.map((p, i) => (
          <div key={p.title} className={`flagship-card ${p.cardClass} reveal${i === 1 ? ' d2' : ''}`}>
            <div className="fc-head">
              <div className={`fc-icon-wrap ${p.cardClass === 'fc-legal' ? 'fci-legal' : 'fci-hr'}`}>{p.icon}</div>
              <span className="fc-badge fb-dev"><span className="fb-dot"></span>{p.status}</span>
            </div>
            <div className={`fc-sector ${p.sectorClass}`}>{p.sector}</div>
            <h3 className="fc-title">{p.title}</h3>
            <p className="fc-tagline">{p.tagline}</p>
            <div className="fc-pain">
              <div className="fc-pain-label">The Problem</div>
              <div className="fc-pain-text">{p.pain}</div>
            </div>
            <p className="fc-desc">{p.description}</p>
            <div className="fc-features">
              {p.features.map((f) => <div key={f} className="fc-feat">{f}</div>)}
            </div>
          </div>
        ))}
      </div>

      <div className="initiative-strip reveal">
        <div className="strip-label">More AI Initiatives</div>
        <div className="strip-scroll">
          {content.initiatives.map((init) => (
            <div key={init.title} className="init-card">
              <div className="init-icon">{init.icon}</div>
              <div className="init-title">{init.title}</div>
              <div className="init-desc">{init.desc}</div>
              <span className={`init-tag${init.tagVariant === 'green' ? ' g' : init.tagVariant === 'caramel' ? ' o' : ''}`}>{init.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
